import {Form, Input, Modal, Select} from 'antd';
import {debounce, set} from 'lodash';
import {debounceDelay} from '../../common/constants';
import {useAppDispatch, useAppSelector} from '../../common/hooks';
import {customerBattery, customersList} from '../customers/customersSlice';
import {assignBattery, reAssignBattery} from './rackScreenSlice';
import {useEffect, useState} from 'react';

const AssignBatteryModal = ({
  isOpen,
  setIsOpen,
  rack_id,
  station_id,
  swapModal,
}: {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  rack_id: number;
  station_id: number;
  swapModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const customerOptions = useAppSelector((state) => state.customers.customers.pageData);
  const orgId = useAppSelector((state) => state.auth.user.details.organisationId);
  const dispatch = useAppDispatch();
  const [isReassign, setIsReassign] = useState(false);
  const [batteryAssignForm] = Form.useForm();

  const handleCustomerBouncing = debounce((e) => {
    dispatch(customersList({search: e, is_active: true}));
  }, debounceDelay);

  const handleAssignBatteryForm = (values: {customer_id: number}) => {
    const payload: any = {};
    payload.customer_id = values.customer_id;
    payload.station_id = station_id;
    payload.rack_id = rack_id;
    console.log(payload);
    dispatch(assignBattery(payload))
      .unwrap()
      .then(() => {
        setIsOpen(false);
        swapModal(true);
      });
  };

  const handleReAssignBattery = (values: {customer_id: number; reason: string}) => {
    const payload: any = {};

    payload.customer_id = values.customer_id;
    payload.reason = values.reason;
    payload.station_id = station_id;
    payload.rack_id = rack_id;
    console.log(payload);
    dispatch(reAssignBattery(payload))
      .unwrap()
      .then(() => {
        setIsOpen(false);
        swapModal(true);
      });
  };

  useEffect(() => {
    dispatch(customersList({is_active: true}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCustomer = (e: number) => {
    dispatch(customerBattery(e))
      .unwrap()
      .then((e) => {
        if (e.data.length > 0) {
          setIsReassign(true);
        } else setIsReassign(false);
      });
  };
  return (
    <Modal
      title={isReassign ? 'ReAssign battery' : 'Assign Battery'}
      open={isOpen}
      maskClosable={false}
      onCancel={() => {
        setIsOpen(false);
      }}
      okText={isReassign ? 'ReAssign' : 'Assign'}
      onOk={() => {
        batteryAssignForm
          .validateFields()
          .then((values) => {
            isReassign ? handleReAssignBattery(values) : handleAssignBatteryForm(values);
          })
          .catch((info) => {
            console.error('Validate Failed:', info);
          });
      }}
    >
      <Form
        name='assignBattery'
        form={batteryAssignForm}
        labelCol={{span: 8}}
        wrapperCol={{span: 14}}
        layout='horizontal'
      >
        <Form.Item
          name='customer_id'
          label='Customer name'
          rules={[
            {
              required: true,
              message: 'Select a customer ',
            },
          ]}
        >
          <Select
            style={{width: '200px'}}
            placeholder='Select customer'
            showArrow
            allowClear
            showSearch
            filterOption={false}
            onSearch={(e) => {
              if (e.length > 2) handleCustomerBouncing(e);
            }}
            onChange={handleCustomer}
          >
            {customerOptions.map((x, i) => (
              <Select.Option key={i} value={x.id}>
                {x.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        {isReassign && (
          <Form.Item
            name='reason'
            label='Reason'
            rules={[
              {
                required: true,
                message: 'Reason',
              },
            ]}
          >
            <Input.TextArea maxLength={100} rows={3} placeholder='reason' showCount />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default AssignBatteryModal;
